console.log('env settings');
console.log(process.env);

const localdev = {
    baseUrl: "https://localhost:44300",
    baseApiUrl: "https://localhost:44300/api",
    baseWebUrl: "http://localhost:8086",
    jobSectionsUrl: "http://localhost:8090/",
    paymentsUrl: "http://localhost:3005/account-settings",
    // Entra External ID (formerly B2C) configuration
    // Updated to new CIAM app registration
    entraClientId: "d5589718-90df-4b39-9709-5c32abb9228b",
    entraTenantName: "VelappityDevExternalId", // ensure this matches initial domain prefix before .onmicrosoft.com if different
    entraTenantId: "b3e2afff-5017-4337-bd9a-03dc8315beed", // new tenant id provided
    baseAnonApiUrl: "https://velappity-dev-anon-apim.azure-api.net/api"
}

const development = {
    baseUrl: "https://velappity-dev-api.azurewebsites.net",
    baseApiUrl: "https://velappity-dev-api.azurewebsites.net/api",
    baseWebUrl: "https://velappity-dev.azurewebsites.net",
    jobSectionsUrl: "https://velappity-dev-components.azurewebsites.net",
    paymentsUrl: "https://velappity-dev-payments.azurewebsites.net",
    entraClientId: "d5589718-90df-4b39-9709-5c32abb9228b",
    entraTenantName: "VelappityDevExternalId", // confirm matches tenant initial domain
    entraTenantId: "b3e2afff-5017-4337-bd9a-03dc8315beed",
    baseAnonApiUrl: "https://velappity-dev-anon-apim.azure-api.net/api"
}

const test = {
    baseUrl: "https://velappity-test-api.azurewebsites.net",
    baseApiUrl: "https://velappity-test-api.azurewebsites.net/api",
    baseWebUrl: "https://velappity-test.azurewebsites.net",
    jobSectionsUrl: "",
    paymentsUrl: "",
    entraClientId: "37e987a8-0be7-4f0c-bae6-50b1baf7d837",
    entraTenantName: "VelappityTestExternalId", // preview/test
    entraTenantId: "04b724b1-8e9e-4ad4-bc57-1a737d893860",
    baseAnonApiUrl: "https://velappity-test-anon-apim.azure-api.net/api"
}

const productionRc = {
    baseUrl: "https://velappity-prod-api-rc.azurewebsites.net",
    baseApiUrl: "https://velappity-prod-api-rc.azurewebsites.net/api",
    baseWebUrl: "https://velappity-prod-web-rc.azurewebsites.net",
    jobSectionsUrl: "",
    paymentsUrl: "",
    entraClientId: "d5589718-90df-4b39-9709-5c32abb9228b", // provisional until prod RC app provided
    // TODO: supply correct production RC Entra values (clientId, tenantName, tenantId)
    entraTenantName: "VelappityProdExternalId", // assuming same as production if single tenant
    entraTenantId: "b3e2afff-5017-4337-bd9a-03dc8315beed" // provisional placeholder (update if different for prod RC)
}

const production = {
    baseUrl: "https://app-api.velappity.com",
    baseApiUrl: "https://app-api.velappity.com/api",
    baseWebUrl: "https://app.velappity.com",
    jobSectionsUrl: "",
    paymentsUrl: "",
    entraClientId: "d5589718-90df-4b39-9709-5c32abb9228b", // provisional until dedicated production app id supplied
    // TODO: supply production Entra client/tenant GUIDs if different
    entraTenantName: "VelappityProdExternalId",
    entraTenantId: "b3e2afff-5017-4337-bd9a-03dc8315beed", // provisional placeholder (update if production differs)
    baseAnonApiUrl: "https://velappity-prod-anon-apim.azure-api.net/api"
}

let environmentConfig = {};

switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'localdev':
    default:
        environmentConfig = localdev;
        break;
    case 'development':
        environmentConfig = development
        break;
    case 'test':
        environmentConfig = test;
        break;
    case 'productionRc':
        environmentConfig = productionRc;
        break;
    case 'production':
        environmentConfig = production;
        break;
}

export const apiConfig = {
    ...environmentConfig
}


export const USE_IDENTITY_SERVER = process.env.REACT_APP_USE_IDENTITY_SERVER === "true";